import { render, staticRenderFns } from "./serviceOrderTemplate.vue?vue&type=template&id=e6f20218&scoped=true"
import script from "./serviceOrderTemplate.vue?vue&type=script&lang=js"
export * from "./serviceOrderTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f20218",
  null
  
)

export default component.exports